import { useEffect, useRef } from "react";
import { ChevronDown } from "lucide-react";

const HERO_IMAGE = "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1920&q=80&fit=crop";

export default function Hero() {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (el) {
      setTimeout(() => el.classList.add("visible"), 100);
    }
  }, []);

  const scrollToContact = (e) => {
    e.preventDefault();
    document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });
  };

  const scrollDown = (e) => {
    e.preventDefault();
    document.querySelector("#services")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={HERO_IMAGE}
          alt="Modern luxury interior architecture"
          className="w-full h-full object-cover"
          loading="eager"
        />
        {/* Semi-transparent dark overlay */}
        <div className="absolute inset-0" style={{ backgroundColor: "rgba(0,0,0,0.55)" }} />
      </div>

      {/* Content */}
      <div
        ref={ref}
        className="animate-on-scroll relative z-10 max-w-7xl mx-auto px-6 md:px-12 py-32 md:py-0 w-full"
      >
        <div className="max-w-2xl">
          {/* Accent line */}
          <div className="w-16 h-[2px] bg-gold mb-8" />

          <h1
            data-testid="hero-heading"
            className="font-heading text-4xl sm:text-5xl lg:text-6xl text-white font-bold leading-[1.1] tracking-[-0.02em]"
          >
            Building Dreams.
            <br />
            Designing Spaces.
          </h1>

          <p
            data-testid="hero-subheading"
            className="font-body text-base md:text-lg text-white/75 mt-8 max-w-lg leading-relaxed"
          >
            Giri Interiors and Constructions — transforming visions into
            exceptional living and working spaces with precision craftsmanship.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mt-12">
            <a
              href="#contact"
              onClick={scrollToContact}
              data-testid="hero-cta-button"
              className="inline-flex items-center justify-center font-body text-sm font-medium bg-gold text-charcoal px-8 py-4 hover:bg-gold-light transition-all duration-300 hover:-translate-y-[2px] hover:shadow-xl"
            >
              Get a Free Quote
            </a>
            <a
              href="#portfolio"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector("#portfolio")?.scrollIntoView({ behavior: "smooth" });
              }}
              data-testid="hero-portfolio-button"
              className="inline-flex items-center justify-center font-body text-sm font-medium border border-white/30 text-white px-8 py-4 hover:border-gold hover:text-gold transition-all duration-300"
            >
              View Our Work
            </a>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <button
        onClick={scrollDown}
        data-testid="hero-scroll-down"
        className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10 text-white/60 hover:text-gold transition-colors duration-300 animate-bounce"
        aria-label="Scroll down"
      >
        <ChevronDown size={28} />
      </button>
    </section>
  );
}
